export default __webpack_public_path__ + "static/media/ThumbIcon.43b205f4.svg";